var module = angular.module('octopusApp.projects');

module.controller('ProjectEditController', function ($scope, $stateParams, busy, pageTitle, projectState, octopusRepository, $location, unsavedChanges, octoDialog, octopusAuthenticator, octopusPermissionSet){
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.project = null;
    $scope.projectGroups = null;
    $scope.otherProjects = null;
    $scope.createOptions = {};
    $scope.createOptions.clone = null;

    isLoading.promise(octopusRepository.ProjectGroups.all().then(function (groups) {
        isLoading.promise(octopusRepository.Lifecycles.all().then(function (lifecycles) {
            var projectId = $stateParams.projectId;
            var groupId = $stateParams.grpid || $location.search().grpid;
            var cloneFromId = $location.search().clone;

            $scope.lifecycles = lifecycles;
            $scope.lifecyclesById = _.object(_.pluck(lifecycles, "Id"), lifecycles);
            $scope.projectGroups = groups;

            if (projectId) {
                isLoading.promise(projectState.load().then(function (project) {
                    isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
                        if (project.ProjectConnectivityPolicy == null) {
                            project.ProjectConnectivityPolicy = {
                                OfflineDeploymentBehavior: "Fail"
                            };
                        }
                        $scope.project = project;
                        $scope.deploymentProcess = deploymentProcess;
                        $scope.view = { versionFromPackage: !!project.VersioningStrategy.DonorPackageStepId };
                        $scope.packageActions = _.filter(
                            _.flatten(
                                _.map(deploymentProcess.Steps,
                                    function(s) { return s.Actions; })),
                            function(a) { return !!a.Properties["Octopus.Action.Package.PackageId"]; });
                    }));
                    pageTitle(project.Name + " settings");
                }));
            } else {
                isLoading.promise(octopusRepository.Alerts.list().then(function(alerts) {
                    $scope.alerts = alerts;
                }));
                isLoading.promise(octopusRepository.Projects.all().then(function(otherProjects){
                    if (cloneFromId) {
                        $scope.createOptions.clone = cloneFromId;
                    }
                    $scope.otherProjects = otherProjects;

                    if (!groupId && groups.length) {
                        groupId = groups[0].Id;
                    }

                    $scope.project = { ProjectGroupId: groupId, LifecycleId: $scope.lifecycles[0].Id, DefaultToSkipIfAlreadyInstalled: false, VersioningStrategy: { Template: '#{Octopus.Version.LastMajor}.#{Octopus.Version.LastMinor}.#{Octopus.Version.NextPatch}' } };
                    $scope.view = { versionFromPackage: false };
                    pageTitle("Create project");
                }));
            }
        }));
    }));

    $scope.save = function() {
        if ($scope.view.versionFromPackage) {
            $scope.project.VersioningStrategy.Template = null;
        } else {
            $scope.project.VersioningStrategy.DonorPackageStepId = null;
        }

        var doSave = $scope.project.Id ?
            octopusRepository.Projects.modify($scope.project) :
            octopusRepository.Projects.create($scope.project, $scope.createOptions);

        isSaving.promise(doSave.then(function (saved) {
            unsavedChanges.saved();

            if (!$scope.project.Id)
            {
                octopusRepository.Users.getPermissions(Octopus.App.currentUser).then(function(permissions) {
                    octopusAuthenticator.setCurrentPrincipal(Octopus.App.currentUser, permissions.Permissions);
                    octopusPermissionSet.refresh();
                    $location.path("/projects/" + saved.Slug);
                });
            }
            else
      {
          $location.path("/projects/" + saved.Slug);
      }
        }));
    };

    $scope.resetVersionTemplate = function() {
        $scope.project.VersioningStrategy.Template =
          '#{Octopus.Version.LastMajor}.#{Octopus.Version.LastMinor}.#{Octopus.Version.NextPatch}';
    };

    $scope.$watch('project.TenantedDeploymentMode', function (nv, ov) {
        if (nv === 'Untenanted') {
            octopusRepository.Tenants.list({projectId: $scope.project.Id}).then(function (results) {
                if (results.TotalResults > 0) {
                    octoDialog.alertMessageBox({
              title: 'Tenants are connected to this project',
              message: 'You can not disable tenanted deployments because some tenants are connected to this project. Please disconnect all tenants from this project, and then disable tenanted deployments.',
          }).finally(function () {
              $scope.project.TenantedDeploymentMode = ov;
          });
                }
            });
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_edit_controller.js
// module id = 514
// module chunks = 1